import React from 'react';
import {connect} from 'react-redux';
import {Field} from 'redux-form';
import {injectIntl} from "react-intl";

import ExpandSection from "../../Generic/expandSection";
import {toggleSectionOpened} from "../AccountActions";
import {ACCOUNT_SECTIONS} from "./sectionNames";
import {FormField, phoneValidator, required, requiredPhoneValidator, requiredWithLength} from "../FormField";
import AccountTwoFaLabel from "../AccountTwoFa/AccountTwoFaLabel";

class CompanyInformation extends React.Component {

  render() {

    const {intl} = this.props;
    const {canEditCompanyName, canEditName, isFabricator, canEditFields, canEditPrimaryEmail, canEditPhone2,
      isEmployee, clientType} = this.props.accountPageInfo;

    return (
      <ExpandSection opened={this.props.sectionsOpened.includes(ACCOUNT_SECTIONS.company_information)}
                     onClick={() => this.props.toggleSectionOpened(ACCOUNT_SECTIONS.company_information)}
                     title={intl.formatMessage({
                       id: isFabricator ? "account.accountInfo.sectionTitle.companyInformation" : "account.accountInfo.sectionTitle.generalInfo"
                     })}>
        <div className="acc-container">
          <div className="acc-container__row">
            <div className="acc-block">
              <Field name="companyName"
                     component={FormField}
                     label={`${intl.formatMessage({id: "account.accountInfo.companyName"})} ${isFabricator ? '*' : ''}`}
                     disabled={!canEditFields || !canEditCompanyName}
                     validate={canEditCompanyName && (clientType !== "Client") ? requiredWithLength(3, 100) : null}/>
              <Field name="firstName" type="text"
                     component={FormField}
                     label={`${intl.formatMessage({id: "account.accountInfo.firstName"})} *`}
                     validate={required}
                     disabled={!canEditFields || !canEditName}/>
              <Field name="lastName"
                     type="text"
                     component={FormField}
                     label={`${intl.formatMessage({id: "account.accountInfo.lastName"})} *`}
                     validate={required}
                     disabled={!canEditFields || !canEditName}/>
              <Field name="primaryEmail"
                     component={FormField}
                     label={`${intl.formatMessage({id: "account.accountInfo.primaryEmail"})} *`}
                     validate={required}
                     disabled={!canEditFields || !canEditPrimaryEmail}/>
              {isEmployee ? null : (
                <Field name="secondaryEmail"
                       component={FormField}
                       label={intl.formatMessage({id: "account.accountInfo.secondaryEmail"})}
                       disabled={!canEditFields}/>
              )}
            </div>
            <div className="acc-block">
              {isEmployee ? null : (
                <Field name="phone1"
                       component={FormField}
                       label={`${intl.formatMessage({id: "account.accountInfo.primaryPhone"})} *`}
                       labelAfter={<AccountTwoFaLabel/>}
                       validate={requiredPhoneValidator}
                       disabled={!canEditFields}/>
              )}
              {isEmployee ? null : (
                <Field name="phone2"
                       component={FormField}
                       label={intl.formatMessage({id: "account.accountInfo.secondaryPhone"})}
                       validate={phoneValidator}
                       disabled={!canEditFields || !canEditPhone2}/>
              )}
              {isEmployee ? null : (
                <Field name="phone3"
                       component={FormField}
                       label={intl.formatMessage({id: "account.accountInfo.additionalPhone"})}
                       validate={phoneValidator}
                       disabled={!canEditFields}/>
              )}
              {isFabricator ? (
                <Field name="redirectURL"
                       component={FormField}
                       label={intl.formatMessage({id: "account.accountInfo.redirectUrl"})}
                       disabled={!canEditFields}/>
              ) : null}
            </div>
          </div>
        </div>
      </ExpandSection>
    )
  }

}

const mapStateToProps = (store) => {
  return {
    sectionsOpened: store.accountState.sectionsOpened,
    accountPageInfo: store.accountState.accountPageInfo
  };
};

const mapDispatchToProps = {
  toggleSectionOpened
};

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(CompanyInformation)
)

